import React from "react";

const Trx = ({ trx }) => {
  const HandlerData = KEY => {
    switch (KEY) {
      case "status":
        return {
          name: "وضعیت شارژ",
          value: Renderststus(trx[KEY]),
        };
      case "charge_amount":
        return {
          name: "مبلغ شارژ",
          value: trx[KEY] != null ? trx[KEY] : "ثبت نشده است",
        };
      case "last_amount":
        return {
          name: "موجودی  قبل شارژ",
          value: trx[KEY] != null ? trx[KEY] : "ثبت نشده است",
        };
    }
  };
  const Renderststus = type => {
    switch (type) {
      case "peyed":
        return "شارژ شده";
      default:
        return "عدم شارژ";
    }
  };
  return (
    <div style={{ marginBottom: "20px" }}>
      <div style={{ borderBottom: "1px solid red" }} className="mb-2">
        <h4 style={{ fontSize: "18px" }}>مشخصات افزایش کیف پول</h4>
      </div>
      <div className="row justify-content-between px-5">
        {Object.keys(trx).map(function (value, key) {
          if (HandlerData(value))
            return (
              <div
                key={key}
                className="col-4 d-flex justify-content-start align-items-center"
              >
                <div>
                  <span style={{ fontWeight: "600" }}>
                    {HandlerData(value)["name"]} :{" "}
                  </span>
                </div>
                <div>
                  <span style={{ fontWeight: "500" }}>
                    {" "}
                    {HandlerData(value)["value"]}{" "}
                  </span>
                </div>
              </div>
            );
        })}
      </div>
    </div>
  );
};

export default Trx;
